module.exports = __webpack_public_path__ + "static/media/homeInactive.861984d3.svg";